var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('VueApexCharts',{attrs:{"width":"500","type":"pie","options":_vm.pieChartOptions,"series":_vm.chartSeries}}),_c('pieDetails',{attrs:{"selectedResult":_vm.selectedResult,"semId":_vm.semId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }